import Image from 'next/image'

import { Text } from '@/shared/components/typography'

const UnitTemplate = ({ name }: { name: string }) => {
  return (
    <div className="flex flex-col items-center gap-6 text-center">
      <Text level="title3" weight="bold" color="text090">
        지금 주차를 시작해 주세요.
      </Text>
      <Text level="text2" color="caution070">
        {`${name}라고 적혀있는`}
        <br />
        {`주차면에 주차해 주세요.`}
      </Text>
      <Image
        src="/images/share_unit.png"
        alt="구획 주차장"
        width={275}
        height={145}
        unoptimized
        className="h-full w-full px-[27px] pt-3"
      />
    </div>
  )
}

export default UnitTemplate
